<template>
  <v-row>
    <v-col>
      <hot-table
        ref="excel"
        :data="localValue"
        :row-headers="true"
        :col-headers="_.map(headers, h => h.text)"
        :columns="columns"
        :context-menu="true"
        :allow-remove-row="true"
        :license-key="'non-commercial-and-evaluation'"
        :settings="spreadSheetOptions"
      />
    </v-col>
  </v-row>
</template>

<script>
import { HotTable } from '@handsontable/vue';
import { mapActions, mapGetters } from 'vuex';
import ModelableMixin from '../../mixins/modelable';

export default {
  name: 'UploadPartSpreadSheet',

  mixins: [
    ModelableMixin,
  ],

  components: {
    HotTable,
  },

  props: {
    parts: {},
  },

  data: () => ({
    serial: [
    ],

    thicknesses: [

    ],
  }),

  computed: {
    ...mapGetters('materials', {
      find: 'find',
    }),

    materials() {
      return this.find({ query: {} }).data;
    },

    headers() {
      return [
        {
          text: 'Part No.',
          value: 'partNo',
        },
        {
          text: 'Filename',
          value: 'fileName',
        },
        {
          text: 'Material',
          value: 'material',
        },
        {
          text: 'Finish',
          value: 'finish',
        },
        {
          text: 'Serial',
          value: 'serial',
        },
        {
          text: 'Thickness',
          value: 'thickness',
        },
      ];
    },

    columns() {
      return [
        {
          data: 'partNo',
          type: 'text',
        },
        {
          data: 'fileName',
          type: 'text',
        },
        {
          data: 'material',
          type: 'dropdown',
          source: _.map(this.materials, m => m.kind),
        },
        {
          data: 'finish',
          type: 'dropdown',
          source: [
            'None', 'Clear Zinc', 'Protective Oil', 'Ecoating',
          ],
        },
        {
          data: 'serial',
          type: 'dropdown',
          source: this.serial,
        },
        {
          data: 'thickness',
          type: 'dropdown',
          source: this.thicknesses,
        },
      ];
    },

    spreadSheetOptions() {
      return {
        width: '100%',

        stretchH: 'all',

        fillHandle: {
          direction: 'vertical',
          autoInsertRow: false,
        },

        beforeChange: (changes, source) => {
          /* changes is an array where
          * 0 is an array of size 4 WHERE
          * 0 is the row index
          * 1 is column name
          * 2 is the previous value
          * 3 is the new value
          * */

          const table = this.$refs.excel.hotInstance;

          if (source === 'loadData' || source === 'internal' || changes.length > 1) {
            return;
          }
          const rowIndex = changes[0][0];
          const columnName = changes[0][1];
          const oldValue = changes[0][2];
          const newValue = changes[0][3];

          if (columnName === 'material' && oldValue !== newValue) {
            table.setDataAtRowProp(rowIndex, 'serial', '', 'internal');
            table.setDataAtRowProp(rowIndex, 'thickness', '', 'internal');

            this.setSerial(undefined, newValue);
          } else if (columnName === 'serial' && oldValue !== newValue) {
            table.setDataAtRowProp(rowIndex, 'thickness', '', 'internal');

            this.setThickness(table.getDataAtRowProp(rowIndex, 'material'), newValue);
          }
        },
      };
    },
  },

  methods: {
    setSerial(index, kind) {
      this.serial = _.map(
        _.get(
          _.find(this.materials, m => m.kind === kind),
          'serials',
          [
          ],
        ),
        s => s.serial,
      );
    },

    setThickness(kind, serial) {
      this.thicknesses = _.find(
        _.find(
          this.materials, m => m.kind === kind
        ).serials,
        s => s.serial === serial
      ).thicknesses;
    },
  },
};
</script>

<style src="../../../../node_modules/handsontable/dist/handsontable.full.css" />
